import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { ToastService } from '../toast.service';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { IonSlides } from '@ionic/angular';
import { Platform } from '@angular/cdk/platform';
import { LocationService } from '../location.service';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { NativeGeocoderOptions, NativeGeocoder, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator/ngx';
import { AdsFetchService } from '../ads-fetch.service';
import { BottomSheet } from '../bottom.sheet';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DomSanitizer } from '@angular/platform-browser';
import { ThumbnailService } from '../thumbnail.service';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
let i = 0;
declare var google;
let userLatLng,custLatLng,custLat;

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent  {

  constructor(private service: ApiService,protected sanitizer: DomSanitizer,
    public auth: AuthService,
    public handler: HandlerService,
    private router: Router,  
    public location: LocationService,
    public toast: ToastService,
    private LocationAccuracy: LocationAccuracy,
    public ad: AdsFetchService,
    private platform:Platform,
    private loc: Geolocation,
    public thumb:ThumbnailService,
    private launchNavigator: LaunchNavigator,
    private geoCoder:NativeGeocoder,
    private iab: InAppBrowser,
    public bottomSheet: MatBottomSheet) { }
    @ViewChild('map',{static: false}) mapElement: ElementRef;
    map: any;
    marker:any;
    itemId;
    locateCheck:boolean=false;
    editOrder;
    maped:boolean=false;
    active: boolean = false;
    switch: boolean = false;
    popLoad:boolean = false;
    mobileView:boolean = false;
    orderConfirmPop:boolean=false;
    gridView:boolean=true;
    backView:boolean=false;
    packView:boolean=true;
    grid:boolean=false;
    list:boolean=true;
    viewage:boolean=false;
    purchaseCategory;
    categoryList;
    numb;
    cId;
    grid1:boolean=false;
    list1:boolean=true;
    grid2:boolean=false;
    list2:boolean=true;
    purcView:boolean=true;
    storeObj: any = [];
    packService:any = [];
    indService;
    serviceInc:boolean=false;
    serviceDetails: any = [];
    serviceRegions:any=[];
    modelObj;
    makeObj;
    modelName;
    modelId;
    makeName;
    makeId;
    typeObj:any=[];
    typeName;
    typeId;
    typeCode;
    itemCategoryObj:any=[];
    itemTypeId;
    typePopup:boolean;   
    categories;
    categoryCode;
    slideOpts = {
      grabCursor:true,
      slidesPerView:1.1,
      centeredSlides:true,
      spaceBetween:4,
      initialSlide: 1,
      autoplay:true,
      speed: 500
    };
    openDetailPop:boolean;
    regionLoader:boolean;
       search;
       regionsPop:boolean=true;
       addressTrue:boolean=true;
       android;
       lat;lan;
       packCategory;
       allAds: any = [];
       category;
       package;
       Ind;
       name;
       itemCode;
       url;
    loader:boolean=false;
    cardLoader:boolean ; 
    pendingBtn:boolean = false;   
 ReqId;
 src:any;
 video:boolean = false;
 appStatus;
 subsPending:any=[];
 orderPending:any=[];
 puchasePending:any=[];
 monthObj: any = [{id:1, name: "JAN"},
 {id:2, name: "FEB"},
 {id:3, name:"MAR"},
 {id:4, name:"APR"},
 {id:5,name:"MAY"},
 {id:6,name:"JUN"},
 {id:7,name:"JUL"},
 {id:8,name:"AUG"},
 {id:9,name:"SEP"},
 {id:10,name:"OCT"},
 {id:11,name:"NOV"},
 {id:12,name:"DEC"}];
 amtPending:any=[];
 Paymentpop:boolean=false;
 orderValue;
 orderLen;
 categoryId;
 localAds:any = [];
 orderItems:any=[];
 cartLength;
 dateFormat;
 itemIdType;
 cataname;
    ionViewWillEnter(){
      this.orderConfirmPop=false;
      this.openDetailPop=false;
      this.loader=true;
      this.orderValue= sessionStorage.getItem('orderValue')
      this.orderLen=sessionStorage.getItem('orderLen')
      this.typePopup=false;
      this.location.pop=false;
      this.dateFormat = this.auth.getDateformat();
      this.getLocalStorageAddress();
      if(this.orderValue==0 && this.orderLen==0){
        localStorage.removeItem('orderId');
        localStorage.removeItem('cateId');
        this.cartLength="";
      }
      if(!localStorage.getItem('orderId')){
        this.cartLength="";
      }
      if(this.auth.loged() || this.location.stateId){
        this.addressTrue=false;
        this.regionsPop=false;
        this.getCategory();  
      }else{  
        this.addressTrue=false;      
        this.regionsPop=true;
        this.getServiceLocations();
        this.getCategory();  
      }
      sessionStorage.setItem('vendorApp','true');
      this.active=false;
      sessionStorage.setItem('vendorApp',JSON.stringify(this.active))
   
      if(this.auth.checkCapability('SC')||this.auth.checkCapability('SP')||this.auth.checkCapability('FSA') ){
        this.viewage=true;
      }else{
        this.viewage=false; 
      }
      // sessionStorage.removeItem('itemTypeId')  
      sessionStorage.removeItem('orderId')
      sessionStorage.removeItem('region')
      sessionStorage.removeItem('cateCode')
      sessionStorage.removeItem('make')
      sessionStorage.removeItem('typeCode')
      sessionStorage.removeItem('model')
      sessionStorage.removeItem('cost')  
      sessionStorage.removeItem('dummyValue') 
      sessionStorage.removeItem('PayCost')
      sessionStorage.removeItem('month')
      sessionStorage.removeItem('year')  
      this.makeName="";
      this.makeId="";
      this.modelId="";
      this.modelName="";
      this.typeName="";
      this.typeId="";
      this.Paymentpop=false;
      this.url = window.location.href;
    i=0;
      this.cardLoader = true;
      if(this.platform.ANDROID || this.platform.IOS){       
        this.android=true;
        this.mobileView=true;
               
      }
      else{    
      // this.handler.res('Please Enter your Address To Search')
      // this.loader = false;
      }
    if(localStorage.getItem('orderId')){
      this.getOrderById();
    }
    }

    getLocalStorageAddress(){
      if(localStorage.getItem('location') && !localStorage.getItem('place')){
        var loc=JSON.parse(localStorage.getItem('location'));
        this.location.lat=loc[0].latitude;
        this.location.lon=loc[0].longitude;
        this.location.zipcode=loc[0].postalCode;
        this.location.street=loc[0].thoroughfare;
        this.location.stateId=loc[0].administrativeArea;
        this.location.cityId=loc[0].locality;    
        this.location.regionId=loc[0].subLocality;
      }

      
      if(localStorage.getItem('place') && !localStorage.getItem('location')){
         var place = JSON.parse(localStorage.getItem('place'));
        place.map(res => {
    
          if (res.types.includes("street_number")) {
            return this.location.houseNbr = res.long_name;
          }
          else if (res.types.includes("postal_code")) {
            return this.location.zipcode = res.long_name;
          }
          else if (res.types.includes("route")) {
            return this.location.street = res.long_name;
          }
          else if (res.types.includes("locality")) {
            return this.location.cityId = res.long_name;
          }
          else if (res.types.includes("sublocality")) {
            return this.location.regionId = res.long_name;
          }
          else if (res.types.includes("administrative_area_level_1")) {
            return this.location.stateId = res.long_name;
          }
          else if (res.types.includes("country")) {
            sessionStorage.setItem("CountryCode",res.short_name)
            // return this.countryCode = res.short_name;
          }
        })
      }
      this.getLocationDetails(this.location.cityId);
    }

    getPendingBalance(){ 
      if(this.auth.loged()){
        this.ReqId = localStorage.getItem('currentUserId')
        // this.service.getPendingBalanceRecord(this.ReqId).subscribe((res:any)=>{
        //   if(res){
        //     this.subsPending=res;         
        //     this.pendingBtn = true;
        //     this.subsPending.map(val=>{          
        //       this.category.map(val1=>{
        //         if(val.categoryId==val1.id){
        //           Object.assign(val,{categoryName:val1.name})
        //         }
        //       })
        //     })
        //   this.subsPending.map(res1=>{
        //     res1.paymentDetails.map(res2=>{        
        //       if(res2){                
        //         this.monthObj.map(dat1 =>{
        //            if(res2.month == dat1.id){
        //              Object.assign(res2,{monthName:dat1.name})
        //            }
        //         })
        //       }  
        //     })          
        //   });

        //   }
        // })
        this.service.getPendingBalanceOrder(this.ReqId).subscribe((res:any)=>{
          if(res){
            this.orderPending=res;
            this.pendingBtn = true;
            // this.puchasePending = this.orderPending.filter(res=>{return (res.status==7 || res.status==2|| res.status==4|| res.status==6)&&res.orderType==2 &&res.paymtStatus==1 }) 
            this.orderPending = this.orderPending.filter(res=>{ return (res.status==7 || res.status==3|| res.status==10|| res.status==9|| res.status==12)&& res.paymtStatus==1&&res.orderType==1 })
            this.orderPending.map(val=>{          
              this.category.map(val1=>{
                if(val.categoryId==val1.id){
                  Object.assign(val,{categoryName:val1.name})
                }
              })
            })

            // this.puchasePending.map(val2=>{          
            //   this.purchaseCategory.map(val3=>{
            //     if(val2.categoryId==val3.id){
            //       Object.assign(val2,{categoryName:val3.name})
            //     }
            //   })
            // })
          }else{
            this.orderPending=[];
            this.pendingBtn=false;
            // this.puchasePending=[];  
                  }
        }) 
      }  
    }

    

    playVideo(data){
      if(data.docId != undefined){
        this.video = true;
        this.service.getAdImage(data.docId).subscribe((res:any)=>{
          this.src= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
        },
        err=>{
          this.handler.err(err);
        })
      }else{
        this.handler.res("No Video Found")
      }  
    }
  
    closeVideo(){
      this.video = false;
      this.src = undefined;
    }
  

    askToTurnOnGPS() {
      this.locateCheck=true;
      this.LocationAccuracy.request(this.LocationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
        () => {  
          this.setLoc()
        },
        error => {
           alert('Device location access is required to fetch your current location')
       this.locateCheck=false;
        }
      
      );
    }

    setLoc(){
      if(this.platform.ANDROID || this.platform.IOS){
        this.locateCheck=true;
        this.loader = true;
          let options: NativeGeocoderOptions = { useLocale: true,maxResults: 1 };
        this.loc.getCurrentPosition().then(res => {
          this.geoCoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options).then((result: NativeGeocoderResult[]) => {
            this.loader = false;
            this.handler.deny = 0;  
            localStorage.removeItem('deny');
              let x: any = result;
              localStorage.removeItem("place");
              localStorage.setItem('location', JSON.stringify(x));
              let loc;
              loc=JSON.parse(localStorage.getItem('location'));
              this.location.lat=loc[0].latitude;
              this.location.lon=loc[0].longitude;
               this.location.zipcode=loc[0].postalCode;
               this.location.street=loc[0].thoroughfare;
               this.location.stateId=loc[0].administrativeArea;
               if(loc[0].locality){
                this.location.cityId=loc[0].locality; 
               }else{
                this.location.cityId=loc[0].subAdministrativeArea; 
               }
               if(loc[0].subLocality){
                this.location.regionId=loc[0].subLocality;
               }else{
                this.location.regionId=loc[0].neighborhood;
               }
              
              //  if(this.location.regionId=="" || this.location.regionId==null ||this.location.regionId==undefined || !this.location.regionId ){
                this.getLocationDetails(this.location.cityId); 
              //  }else{
                // this.getLocationDetails(this.location.regionId); 
              //  }
                      
               this.addressTrue=false;   
               this.location.pop = false;
               this.locateCheck=false;          },
          err=>{
            this.addressTrue=false;   
            this.loader = false;
            this.location.pop = false;
            this.locateCheck=false;
            this.handler.err(err);
          })        
      },
      err=>{
        this.handler.deny++;
        if(this.handler.deny > 2 && !localStorage.getItem('deny')){
          this.handler.staticError("Please turn on location access permission for App,from Settings");
          localStorage.setItem("deny" , "1");
        }
        if(localStorage.getItem('deny')){
          this.handler.staticError("Please turn on location access permission for App,from Settings");
        }
        this.addressTrue=false;   
        this.loader = false;
        this.locateCheck=false;
        this.location.pop = false;
      })
   }else{
    this.addressTrue=false;   
    this.location.pop = false;
    this.loader = false;
    this.locateCheck=false;
   }
   this.location.serviceArea = true;
  }

  getLocationDetails(data){
    if(this.location.cityId=="Chennai" || this.location.cityId=="chennai" || this.location.cityId=="CHENNAI" || 
    this.location.cityId=="Tiruvallur" ||this.location.cityId=="tiruvallur"|| this.location.cityId=="TIRUVALLUR"||
    this.location.cityId=="Thiruvallur" ||this.location.cityId=="thiruvallur"|| this.location.cityId=="THIRUVALLUR"){
    var post={
      "id":790,
      "city":data
    }
    this.service.locationSearch(post).subscribe((res:any)=>{
      if(res !=null || res=="OK"){
        this.location.locationTrue=true;
        localStorage.setItem('locationTrue', 'true');
      }else{
        this.location.locationTrue=false;
        localStorage.setItem('locationTrue', 'false');
        this.handler.err('Selected service is not provided in this region!!! Please select different region');
      }
    },err =>{
      this.location.locationTrue=false;
      localStorage.setItem('locationTrue', 'false');
      this.handler.err(err);
    })
  }else{
    var post1={
      "id":790,
      "region":data
    }
    this.service.locationSearch(post1).subscribe((res:any)=>{
      if(res !=null){
        this.location.locationTrue=true;
        localStorage.setItem('locationTrue', 'true');
      }else{
        this.location.locationTrue=false;
        localStorage.setItem('locationTrue', 'false');
        this.handler.err('Selected service is not provided in this region!!! Please select different region');
      }
    },err =>{
      this.location.locationTrue=false;
      localStorage.setItem('locationTrue', 'false');
      this.handler.err(err);
    })
  }
  
  }


   onInput() {
     this.location.serviceArea = true;
    this.location.autoComplete();
     }
  route(id,data,data1){
    this.itemId = id;
    this.itemCode = data;
    if(!localStorage.getItem('orderId') || data!="CAR"){
      sessionStorage.removeItem('itemTypeId')  
    }       

    sessionStorage.removeItem('orderId') 
    sessionStorage.removeItem('cateCode')
    sessionStorage.removeItem('make')
    sessionStorage.removeItem('typeCode')
    sessionStorage.removeItem('model')    
    sessionStorage.setItem('categoryId',id)
     if( this.location.cityId){
       var locateTrue = localStorage.getItem('locationTrue')
       if(locateTrue == 'true'){
        if(this.url.includes('bookservice1')){
          sessionStorage.setItem('cateCode',data)  
          sessionStorage.setItem('mixedbooking',data1)     
          sessionStorage.setItem('region',this.location.regionId)
          if(localStorage.getItem('orderId')){ 
            if (localStorage.getItem('cateId') != id){
              this.orderConfirmPop=true;
              this.categoryList.map(res=>{
                if(res.id == localStorage.getItem('cateId')){
                  this.cataname=res.name;
                }
              }) 
            }else{
              this.Stay();           
            }          
            
               
          }else{
            localStorage.setItem('cateId',id)
            localStorage.removeItem('orderId') 
            sessionStorage.removeItem('itemTypeId')
            this.router.navigate(['/subservice1']);  
          }
        }else{
          sessionStorage.setItem('cateCode',data)
          sessionStorage.setItem('mixedbooking',data1) 
          localStorage.setItem('cateId',id)
          sessionStorage.setItem('region',this.location.regionId)
          this.router.navigate(['/subservice']);
        } 
       }else{
        this.handler.error('Selected service is not provided in this region!!! Please select different region');
       }    
    }else{
      if(this.location.regionId || this.location.cityId){
        this.handler.error('Please enter different service location to proceed'); 
      }else{
        this.handler.error('Please enter a address to search');
      }
 
    }
   
  }

  Stay(){
    if(this.itemId == localStorage.getItem('cateId')){
      sessionStorage.setItem('region',this.location.regionId)
      sessionStorage.setItem('itemTypeId', this.itemTypeId)
      localStorage.setItem('cateId',this.itemId )
      this.router.navigate(['/edit-services']); 
       }else{
      this.orderConfirmPop=false;
    }
  }

  clear(){
    this.cartLength="";
    localStorage.setItem('cateId',this.itemId)
    localStorage.removeItem('orderId') 
    sessionStorage.removeItem('itemTypeId')
    this.router.navigate(['/subservice1']);  
  }

  routePurc(id){     
      if(this.url.includes('bookservice1')){ 
        sessionStorage.setItem('region',this.location.regionId)    
        this.router.navigate(['purchase-items1/', +id]);  
      }else{
        sessionStorage.setItem('region',this.location.regionId)      
        this.router.navigate(['purchase-items/', +id]);
      }    
    
  }
 
  getCategory(){
    this.loader = true;
    this.service.getOrgCategoryDetails().subscribe((res: any) => {
      if(res){
        this.category=res;
        this.packCategory=res;
        this.categoryList=this.category.filter(res=>{return res.activeInd==true && res.code!="HOMEDEL"})
       
        this.cardLoader = false;
        this.name=res.name; 
        this.loader=false;
        this.getPendingBalance();
        // this.getPurCategory();  
        if(JSON.parse(localStorage.getItem('ads'))){
          this.localAds = JSON.parse(localStorage.getItem('ads'));
        }
        if(this.localAds == 0){
          this.ad.getAds(); 
        }else{
          this.ad.allAds = this.localAds;
        }   
    
      }else{
        this.loader=false;
        this.categoryList=[];
      }
         })
      
      
  }

  getPurCategory(){
    this.service.getAllDetailedPurchaseCategory().subscribe((res: any) => {
      if(res){
        this.purchaseCategory=res;   
        // this.getService();
        this.getPendingBalance();
      }else{
        // this.getService();
        this.getPendingBalance();
      }  
    })
  }

  getCustLocation(lat,lon,item,address){
    if(item.lat && item.lon){
      let x=Number(item.lat)
      let y=Number(item.lon)
      custLatLng = new google.maps.LatLng(x,y);
      custLat=[item.lat,item.lon];
      this.openMap(lat,lon)
   }
   else{
    let options: NativeGeocoderOptions = {
      useLocale: true,
      maxResults: 1
  };
     this.geoCoder.forwardGeocode(address, options)
     .then((coordinates: NativeGeocoderResult[]) =>{custLat=[coordinates[0].latitude,coordinates[0].longitude],custLatLng = new google.maps.LatLng(coordinates[0].latitude,coordinates[0].longitude),this.openMap(lat,lon)})
     .catch((error: any) =>{});
   }
  }
  startNavigating(pos){
    let directionsService = new google.maps.DirectionsService;
    let directionsDisplay = new google.maps.DirectionsRenderer;
    directionsDisplay.setMap(this.map);
    directionsService.route({
        origin:pos,
        destination:custLatLng,
        travelMode: google.maps.TravelMode['DRIVING']
    }, (res, status) => {
        if(status == google.maps.DirectionsStatus.OK){
            directionsDisplay.setDirections(res);
        } else {
        }
    });
  }
  openMap(lat,lan){
     userLatLng=[lat,lan]
    let pos= new google.maps.LatLng(lat,lan);
    let mapOptions = {
      center: pos,
      zoom: 100,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    this.marker = new google.maps.Marker({
      position:pos,
      animation: google.maps.Animation.DROP,
      map: this.map
  }); 
    this.startNavigating(pos)
  }
  navigateToGoogleMaps(){
    let options: LaunchNavigatorOptions = {
      start:userLatLng,
    }
    this.launchNavigator.navigate(custLat, options)
    .then(
      success => this.maped=false,
      error => {}
    );
  }

  closePop(){
    this.indService = "";
    this.makeName = "";
    this.makeId = ""; 
    this.modelName = "" ;
    this.modelId = "";
    this.typeName ="";
    this.typeId = "";
    this.typePopup = false;
  }
  
  openLocation(){
    this.location.lat="";
    this.location.lon="";
     this.location.zipcode="";
     this.location.street="";
     this.location.stateId="";
     this.location.cityId="";
     this.location.regionId="";
    this.askToTurnOnGPS();  
    
  }

  popClose(){
    this.location.pop=false;
    this.location.newSearch="";
    this.location.dummy = false;
  }
 
  popClose1(){
    this.location.pop=false;
    this.location.newSearch="";
    this.location.dummy = false;
    this.addressTrue=true;
  }

  openPop(){
    this.location.pop=true;
    this.backView=false;
  }
  openpage(url) {
    if (url) {
      this.iab.create(url, '_system');
        } else {
      this.handler.res('There is no URL')
    }
  }

  ionViewWilLeave(){
    this.search = "";
    this.location.pop=false;
    this.serviceInc=false;
    this.typePopup=false;
  }

  getService(){
    this.cId=21;
    this.Ind=true;
    this.service.getAllItemsByCategory(this.cId,this.Ind).subscribe((res:any)=>{
     this.storeObj = res;   
      this.storeObj = this.storeObj.filter(res=>{return res.packageInd == true && res.itemCategoryId=="21"})    
      this.storeObj.map(dat=>{
      if(dat.imageId){
        this.thumb.getThumbIcon(dat)
      }
    })
      this.loader = false;
      
   },err =>{
     this.handler.err(err)
     this.loader = false;    
   })  
  
  }

  // getDetails(data){
  //   this.indService = data;
  //   this.serviceInc=true; 
  //   this.serviceDetails = data.serviceDetails;    
  // }



  getDetails(data){
    if(this.location.regionId && this.location.locationTrue){
      sessionStorage.removeItem('itemTypeId')  
      sessionStorage.removeItem('orderId') 
      sessionStorage.removeItem('cateCode')
      sessionStorage.removeItem('make')
      sessionStorage.removeItem('typeCode')
      sessionStorage.removeItem('model') 
      this.indService = data;
      this.typePopup = true;
      this.getCustMake();  
    }else{
      this.handler.err("Please enter a address to search"); 
    }
  
  }

  selectItem(){
    if(this.typeId != "" || this.typeId != undefined){
      if(!this.auth.loged()){
        this.serviceInc = true;
        this.typePopup = false;
        this.itemCategory();     
      }else{    
        this.itemCategory();  
        this.subscriptionRoute();    
      }
    }else{
      this.handler.res("Please Enter Required fields");
    }
   
  }


  subscriptionRoute(){
    if(this.categoryCode=="CAR" || this.categoryCode=="HP"){
      sessionStorage.setItem('itemId', this.indService.id)
      sessionStorage.setItem('cateId', this.indService.itemCategoryId)     
      sessionStorage.setItem('typeCode',this.typeCode)
  
    }else{
      sessionStorage.setItem('itemId', this.indService.id)
      sessionStorage.setItem('cateId', this.indService.itemCategoryId) 
      sessionStorage.setItem('itemType',this.indService.subCost[0].itemTypeId)
      sessionStorage.setItem('typeCode',this.typeCode)   
    }       
    this.router.navigate(['/subs-booking'])  
  }

     
  signIn(){  
      if(this.categoryCode=="CAR" || this.categoryCode=="HP"){
        sessionStorage.setItem('itemId', this.indService.id)
        sessionStorage.setItem('cateId', this.indService.itemCategoryId) 
        sessionStorage.setItem('subsInd', this.indService.packageInd )        

      }else{
        sessionStorage.setItem('itemId', this.indService.id)
        sessionStorage.setItem('cateId', this.indService.itemCategoryId) 
        sessionStorage.setItem('itemType',this.indService.subCost[0].itemTypeId)
        sessionStorage.setItem('subsInd', this.indService.packageInd )      
       
      } 
  
        var post={
          "contactNbrMob":'+91'+ this.numb,
          "orgCode":'YB',
          "paless": true,
          "userType":1,
          "roles": ['CUST'],
          "appId":14,
          "addresses":[
            {
              "cityId": this.location.cityId,
              "stateId": this.location.stateId,
              "regionId":this.location.regionId,
              "street":this.location.street,
              "zipcode":this.location.zipcode,
              "lat": this.location.lat,
              "lon": this.location.lon,
              "type": 2,
              "orgId":790
            }
          ]
        }  
        this.service.customerLogin(post).subscribe((res:any)=>{
         if(res){
          window['mock'] = res;  
          this.handler.loginRes(res); 
           this.serviceInc=false;
           this.numb="";
          this.router.navigate(['/validateForSubs'])
         }
        }) 
  
  }

  closePopup(){
    this.serviceInc=false;
    this.numb="";
  }
  closePayPop(){
    this.Paymentpop=false;
  }

  logIn(){  
      if(this.categoryCode=="CAR" || this.categoryCode=="HP" ){
        sessionStorage.setItem('itemId', this.indService.id)
        sessionStorage.setItem('cateId', this.indService.itemCategoryId)       
   
      }else{
        sessionStorage.setItem('itemId', this.indService.id)
        sessionStorage.setItem('cateId', this.indService.itemCategoryId) 
        sessionStorage.setItem('itemType',this.indService.subCost[0].itemTypeId)    

      }     
      this.router.navigate(['/subs-cust-register'])       
     
    } 

  itemCategory(){
    this.service.getOrgCategory().subscribe(res=>{
      this.categories = res;  
     
      if (this.categories.length > 0) {
        this.categories.map(res1 => {
                 if (res1.id == this.indService.itemCategoryId ) {           
            this.categoryCode = res1.code; 
              sessionStorage.setItem('cateCode',this.categoryCode)                                                                           
          }
          }) 
    }
     }) 
     this.getCost();
  }

 

  getCost(){ 
    if(this.itemTypeId != undefined && this.location.regionId != undefined &&this.indService.id  != undefined &&
      this.itemTypeId != "" && this.location.regionId != "" &&this.indService.id  != ""){
        var data={
          "itemTypeId": this.itemTypeId,
          "region": this.location.regionId,
          "serviceId":this.indService.id 
        }
        this.service.getCost(data).subscribe((res:any)=>{
          if(res!=null){
            this.location.markedPrice = res[0].cost;
            sessionStorage.setItem('cost',this.location.markedPrice)
          }else{
            this.handler.error("Please Select Different Location");
            this.location.markedPrice = "";
          }
        }, err => {
          this.handler.err(err);
        })
      }
  }

  getServiceLocations(){
    this.loader=true;
    var post={
      "id":790
    }
    this.service.locationSearch(post).subscribe((res:any)=>{
      this.serviceRegions=res;
    })
  }

  goneThrough(){
    this.regionsPop=false;
    this.addressTrue=true;
  }
   
  routing(){   
        sessionStorage.setItem('itemId', this.indService.id)
        sessionStorage.setItem('cateId', this.indService.itemCategoryId)  
        if(!this.auth.loged())  
        this.router.navigate(['/customer-reg'])
        else{
          this.router.navigate(['/req-booking'])
        }     
    } 

    ionViewWillLeave(){
      this.serviceInc=false;
    }

    changeView(){
      this.list=true;
      this.grid = false;
      this.gridView=true;
    }
  
    intialView(){
      this.grid=true;
      this.list = false;
      this.gridView=false;
    }
    changeView1(){
      this.list1=true;
      this.grid1 = false;
      this.packView=true;
    }
  
    intialView1(){
      this.grid1=true;
      this.list1 = false;
      this.packView=false;
    }
    changeView2(){
      this.list2=true;
      this.grid2 = false;
      this.purcView=true;
    }
  
    intialView2(){
      this.grid2=true;
      this.list2 = false;
      this.purcView=false;
    }

    getItemType(){
      this.service.getItemType().subscribe((res: any)=>{
        this.itemCategoryObj= res;  
        this.itemCategoryObj.map(res1=>{
          if(res1.id==this.itemTypeId){
            this.typeName=res1.name;
            this.typeCode =res1.code;
            sessionStorage.setItem('typeCode',this.typeCode)
          }
        })    
      })
    }

    
  getCustMake(){
    this.popLoad=true;
    this.service.getMake(this.indService.itemCategoryId).subscribe((res:any)=>{ 
      if(res){
        this.makeObj = res;
        this.popLoad=false;
      }  
     
    })
  }

  getCustModel(){
    this.popLoad=true;
    this.service.getModel(this.indService.itemCategoryId,this.makeId).subscribe((res:any)=>{
      if(res){
        this.modelObj = res;
        this.popLoad=false;
      }
      else{
        this.popLoad=false;
        this.handler.res('Model not available for this make!!! Please choose equivalent make')
      }
    },
    err=>{
      this.popLoad=false;
      this.handler.err(err);
     
    })
  }

  getCustitemType(){
    this.popLoad=true;
    this.service.getCustItemType(this.indService.itemCategoryId,this.makeId,this.modelId).subscribe((res:any)=>{
     if(res){
      this.typeObj = res;
      this.typeObj.map(res1=>{
        this.itemTypeId = res1.itemTypes[0].id;
        this.typeName=res1.itemTypes[0].name;
        this.typeCode =res1.itemTypes[0].code;
      })
    
      this.itemTypeId = res[0].itemType;
      sessionStorage.setItem('itemTypeId',this.itemTypeId)  
      sessionStorage.setItem('typeCode',this.typeCode) 
      this.popLoad=false;
    }    else{
      this.popLoad=false;
      this.handler.res('Item Type not available for this make and model!!! Please choose equivalent make')
    }
  },
  err=>{
    this.popLoad=false;
    this.handler.err(err);
    })
  }

  openBottomSheet1(): void { 
    const dialogRef = this.bottomSheet.open(BottomSheet,{
      data: this.makeObj,
    });
    dialogRef.afterDismissed().subscribe((res:any) => {
    this.makeName = res.name; 
    this.makeId = res.id;
    this.modelName = "" ;
    this.typeName ="";
    this.typeId = "";
    this.modelObj="";
    sessionStorage.setItem('make', this.makeName) 
            if(this.makeName){       
          this.getCustModel();
        }   
   
    });
  }

  openBottomSheet2(): void {  
   const dialogRef = this.bottomSheet.open(BottomSheet,{
     data: this.modelObj,
   });
   dialogRef.afterDismissed().subscribe((res:any) => {
     if(res){
       this.modelName = res.name; 
       this.modelId = res.id;
       this.typeName ="";
       this.typeId = "";
       sessionStorage.setItem('model', this.modelName) 
       if(this.modelName){   
        this.getCustitemType();
      }             
     }
   });
 
}

PendingPay(){
  this.Paymentpop=true;
  this.getPendingBalance();
}

pay(id1,data,val){
  sessionStorage.setItem('year',data.year)
  sessionStorage.setItem('month',data.month)
  sessionStorage.setItem('PayCost',val)
  this.router.navigate(['payment-subs/',id1])
}

payOrder(id,data){
  sessionStorage.setItem('PayCost', data.orderAmountStr)
  this.router.navigate(['orders-pay-options/',id])
}

manualSetLoc(){
  this.location.pop=true;
  this.addressTrue=false;
  this.backView=true;
}

changeApp(){
  sessionStorage.setItem('vendorApp',JSON.stringify(this.active))
  if(this.active){
    if(this.auth.loged()){
      if(this.auth.checkCapability('SC')){
        this.router.navigate(['/requests']); 
        }else if(this.auth.checkCapability('SP') && !this.auth.checkCapability('FSA')&&!this.auth.checkCapability('SC')){
          this.router.navigate(['/vendor-request']);
        }else if((this.auth.checkCapability('FSA')||this.auth.checkCapability('SPVR')|| this.auth.checkCapability('VM') ||this.auth.checkCapability('CUSTRQH') ||this.auth.checkCapability('CUSTSUP'))&&!this.auth.checkCapability('SC')){      
          this.router.navigate(['/vendor-manage-order']);
        }
    }else{
      this.router.navigate(['/vendor-register'])
    }
  }else{
    if(this.auth.loged()){
      this.router.navigate(['/bookservice1']) 
    }else{
      this.router.navigate(['/bookservice']) 
    }
   
  }
}


getOrderById(){
  this.service.getOrderByIdOri(localStorage.getItem('orderId')).subscribe((res:any)=>{
    this.editOrder=res;
    this.orderItems=res.itemOrders;
    this.categoryId = res.categoryId;
    this.itemIdType = this.orderItems[0].itemTypeId;
    this.cartLength =res.itemOrders.length;
  })
}

openDetails(){
  if(this.cartLength != 0){
  this.openDetailPop=true;
  }
}


gotoPage(){ 
  sessionStorage.setItem('orderId',this.editOrder.id);
  this.categoryList.map(dat=>{
    if(dat.id==this.editOrder.categoryId){
       sessionStorage.setItem('cateCode',dat.code)
    }
  })
  sessionStorage.setItem('region',this.editOrder.delRegion)
  if(this.editOrder.apptDate){
    this.router.navigate(['review-items']);
  }else{
    this.router.navigate(['req-booking']);
  }
}

  }
    